module.exports = __webpack_public_path__ + "fonts/SourceHanSans-Medium.a7a8b5a8.otf";